// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseLayout_wrapper__RcOl0","main":"BaseLayout_main__2IdkE"};